import { render } from "./SdvPlanModal.vue?vue&type=template&id=b667379e"
import script from "./SdvPlanModal.js?vue&type=script&lang=js"
export * from "./SdvPlanModal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__